export default {
    data() {
        return {
            radios: [1, 2, 3],
            radioSeleccionado: '',
            distancias: [],
        };
    },
    computed: {
        radiosValidos() {
            const cantidad = Number(this.radioSeleccionado);
            if (!Number.isInteger(cantidad) || cantidad < 1 || cantidad > 3) {
                return false;
            }
            if (this.distancias.length !== cantidad) {
                return false;
            }

            return this.distancias.every((value, index) => {
                const distancia = Number(value);
                if (!Number.isFinite(distancia) || distancia <= 0) {
                    return false;
                }
                return index === 0 || distancia > Number(this.distancias[index - 1]);
            });
        },
        mensajeValidacionRadios() {
            const cantidad = Number(this.radioSeleccionado);
            if (!cantidad || this.distancias.length !== cantidad) {
                return 'Debe configurar todos los radios seleccionados.';
            }

            for (let index = 0; index < this.distancias.length; index += 1) {
                const distancia = Number(this.distancias[index]);
                if (!Number.isFinite(distancia) || distancia <= 0) {
                    return `R${index + 1} debe ser mayor que 0.`;
                }
                if (index > 0 && distancia <= Number(this.distancias[index - 1])) {
                    return `R${index + 1} debe ser mayor que R${index}.`;
                }
            }
            return '';
        },
    },
    watch: {
        radioSeleccionado(nuevoValor) {
            const distanciasActuales = [...this.distancias];
            if (nuevoValor < distanciasActuales.length) {
                this.distancias = distanciasActuales.slice(0, nuevoValor);
            } else if (nuevoValor > distanciasActuales.length) {
                const nuevasDistancias = [...distanciasActuales];
                while (nuevasDistancias.length < nuevoValor) {
                    const anterior = Number(nuevasDistancias[nuevasDistancias.length - 1]);
                    nuevasDistancias.push(
                        Number.isFinite(anterior) && anterior > 0 ? anterior + 1 : 0
                    );
                }
                this.distancias = nuevasDistancias;
            }
            this.emitState();
        },
    },
    methods: {
        updateDistancia(index, value) {
            const num = Number(value);
            const distancia = Number.isFinite(num) ? num : 0;
            this.$set(this.distancias, index, distancia);

            const anterior = index > 0 ? Number(this.distancias[index - 1]) : null;
            const mantieneOrden = index === 0 || (
                Number.isFinite(anterior) && anterior > 0 && distancia > anterior
            );

            if (distancia <= 0 || !mantieneOrden) {
                this.resetFollowingDistances(index);
            } else {
                this.ensureFollowingDistances(index);
            }

            // Actualiza inmediatamente la validez para bloquear "Ejecutar".
            this.emitState();

            clearTimeout(this.emitTimeout);
            this.emitTimeout = setTimeout(() => {
                this.emitValidDistances();
            }, 600);
        },
        normalizeDistancia(index) {
            let distancia = Number(this.distancias[index]);
            if (!Number.isFinite(distancia) || distancia <= 0) {
                distancia = 0;
            } else if (index > 0) {
                const anterior = Number(this.distancias[index - 1]);
                if (!Number.isFinite(anterior) || anterior <= 0) {
                    distancia = 0;
                } else if (distancia <= anterior) {
                    distancia = anterior + 1;
                }
            }

            this.$set(this.distancias, index, distancia);
            if (distancia > 0) {
                this.ensureFollowingDistances(index);
            } else {
                this.resetFollowingDistances(index);
            }

            this.emitState();
            this.emitValidDistances();
        },
        ensureFollowingDistances(index) {
            let anterior = Number(this.distancias[index]);
            for (let position = index + 1; position < this.distancias.length; position += 1) {
                const actual = Number(this.distancias[position]);
                if (!Number.isFinite(actual) || actual <= anterior) {
                    this.$set(this.distancias, position, anterior + 1);
                }
                anterior = Number(this.distancias[position]);
            }
        },
        resetFollowingDistances(index) {
            for (let position = index + 1; position < this.distancias.length; position += 1) {
                this.$set(this.distancias, position, 0);
            }
        },
        emitValidDistances() {
            if (this.radiosValidos) {
                this.$emit('generateRings', { distances: [...this.distancias] });
            }
        },
        minimumDistance(index) {
            if (index === 0) return 1;
            const anterior = Number(this.distancias[index - 1]);
            return Number.isFinite(anterior) && anterior > 0 ? anterior + 1 : 1;
        },
        isDistanceDisabled(index) {
            if (index === 0) return false;
            for (let position = 0; position < index; position += 1) {
                const actual = Number(this.distancias[position]);
                if (!Number.isFinite(actual) || actual <= 0) return true;
                if (position > 0 && actual <= Number(this.distancias[position - 1])) {
                    return true;
                }
            }
            return false;
        },
        distanciaEsInvalida(index) {
            const actual = Number(this.distancias[index]);
            if (!Number.isFinite(actual) || actual <= 0) return true;
            return index > 0 && actual <= Number(this.distancias[index - 1]);
        },
    },
};
